import * as service from './service'
export default {
  namespace: 'recruitSelectRecruitType',
  state: {
    cityStatusData: {},
    sureCityData: {}
  },
  effects: {
    * getCityStatus ({ payload }, { call, put }) {
      const res = yield call(service.getCityStatus, payload)
      yield put({
        type: 'save',
        payload: {
          cityStatusData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
